import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export interface PriceAlertState {
  displayPriceAlert: boolean;
  displayEditPriceAlert: boolean;
}

const initialState: PriceAlertState = {
  displayPriceAlert: false,
  displayEditPriceAlert: false,
};

const PriceAlertSlice = createSlice({
  name: "priceAlert",
  initialState,
  reducers: {
    togglePriceAlertModal: (state) => {
      state.displayPriceAlert = !state.displayPriceAlert;
    },
    togglePriceAlertEditModal: (state) => {
      state.displayEditPriceAlert = !state.displayEditPriceAlert;
    },
  },
});

export default PriceAlertSlice;

export const usePriceAlertState = () => useAppSelector((state) => state.priceAlert);

export const { togglePriceAlertModal, togglePriceAlertEditModal } = PriceAlertSlice.actions;
